import React from "react";
import "./CardBlog.styles.css";

export const CardBlog = ({ article, bg_color }) => {
  return (
    <div className="cardsBlog" style={bg_color ? { background: bg_color } : {}}>
      <div className="boxContent">
        <div className="textContent">
          <p className="title">{article?.titulo ?? ""}</p>
          <div className="description">{article?.contenido ?? ""}</div>
        </div>
        <img
          alt={article?.titulo}
          className="content"
          src={article?.imagen ?? "https://concepto.de/wp-content/uploads/2015/02/articulo-e1550962332343.jpg"}
        />
      </div>
    </div>
  );
};
